// frontend/src/components/library/ChallengeCard.js
import React from 'react';
import { Link } from 'react-router-dom';

const ChallengeCard = () => {
    return (
        <Link 
            to="/products/list/tag/Behdani-campaign"
            className="block w-full rounded-xl overflow-hidden shadow-lg hover:opacity-90 transition-opacity"
        >
            <img 
                src="https://s3.afra.kubit.cloud/mahsacanva1365-far-free/profile/2.png"
                alt="بنر به‌ٔانی کتاب"
                className="w-full h-auto object-cover"
            />
        </Link>
    );
};

export default ChallengeCard;